export const ROUTE_PATH_REGEX = {
  BI_INSIGHTS: /^\/insights(\/\w*)?(\/[\w-]*)?/,
  FIVE9_ARU_CONFIGURATION: /^\/admin\/five9AruConfig\/(\w)?/,
}

export const ROUTE_PATHS_PREFIX = {
  AGENT_DYNAMIC_SCHEDULING: '/agentDynamicScheduling',
  AGENT_EXPLORER: '/agentExplorer',
  ANALYTICS_MAIL_SERVER: '/admin/analyticsMailServer',
  ANALYTICS_SUBSTITUTION: '/admin/analyticsSubstitution',
  ANALYTICS: '/analytics',
  APIDOCUMENTATION: '/apiDocumentation',
  APPLICATION_MANAGEMENT: '/admin',
  BULK_CONTACT_EXPORT_MONITORING: '/admin/bulkContactExportMonitoring',
  CONTACT_QUEUE: '/contactQueue',
  CONTACT_GOAL_ADMIN: '/admin/contactGoal',
  DASHBOARD: '/dashboard',
  AR_ASSET_BROWSER: '/dataExplorer/reports',
  AR_DATA_LIBRARY: '/dataExplorer/dataLibrary',
  CDM_SETTINGS: '/dataExplorer/settings',
  DATA_EXPLORER: '/dataExplorer',
  BI_INSIGHTS: '/insights',
  CDM_SHARING_GROUP_ADMIN: '/admin/sharingGroups',
  DEVICE_ASSOCIATIONS: '/admin/deviceAssociations',
  EVALUATION_FORM_GROUPS: '/admin/evaluationFormGroups',
  EVALUATION_FORM_MANAGER: '/admin/evaluationFormManager',
  BULK_CONTACT_OPERATIONS: '/admin/bulkContactOperations',
  INCLUSION_EXCLUSION: '/admin/inclusionExclusion',
  LANDINGPAGE_MANAGEMENT: '/admin/landingPageManagement',
  MESSAGING: '/messaging',
  OUTGOING_MAIL_SERVER: '/admin/outgoingMailServer',
  PERFORMANCE_COACHING: '/performanceCoaching',
  PERFORMANCE_COACHING_AGENT_DASHBOARD: '/performanceCoaching/AgentPerformance',
  PERFORMANCE_COACHING_COACH_DASHBOARD: '/performanceCoaching/TeamPerformance',
  PERFORMANCE_COACHING_ORG_DASHBOARD: '/performanceCoaching/OrganizationPerformance',
  PERFORMANCE_COACHING_ADMIN_DASHBOARD: '/performanceCoaching/MetricAdministration',
  PERFORMANCE_COACHING_SETTINGS: '/admin/performanceCoachingSettings',
  QM_GLOBAL_SETTINGS: '/admin/qmGlobalSettings',
  DATA_TASK_MANAGEMENT: '/admin/dataTaskManagement',
  TIME_OFF_REPORT: '/admin/timeOffReport',
  USER_ATTRIBUTES_MANAGEMENT: '/admin/userAttributesManagement',
  UDM_CONNECTOR_MANAGEMENT: '/admin/udm',
  RT_CONNECTOR_MANAGEMENT: '/admin/rt',
  RECORDING_CONTROLS: '/recordingControls',
  RECORDINGS: '/recordings',
  REPORTS: '/reports',
  SCHEDULING_AGENT_SCHEDULES: '/scheduling/agentSchedules',
  SCHEDULING_INTRADAY_DYNAMIC_SCHEDULING: '/scheduling/intradayDynamicScheduling',
  SCHEDULING_MY_AVAILABILITY: '/scheduling/myAvailability',
  SCHEDULING_MY_SCHEDULE: '/scheduling/mySchedule',
  SCHEDULING_PLANNING: '/scheduling/planning',
  SCHEDULING_SCHEDULE_CHANGE_MANAGEMENT: '/scheduling/scheduleChangeManagement',
  SCHEDULING: '/scheduling',
  TELEOPTI_WFM: '/wfm',
  TEAMS: '/admin/teams',
  TWILIO_CONFIGURATION: '/admin/twilioConfig',
  TASK_MANAGER_CREATE: '/admin/taskManager/create',
  TASK_MANAGER_EDIT: '/admin/taskManager/edit',
  NEW_TASK_MANAGER: '/admin/taskManager',
  PHRASE_MANAGER: '/admin/phraseManager',
  ANALYTICS_CONFIG: '/admin/analyticsConfig',
  TRANSCRIPTION_SEARCH: '/analytics/transcriptionSearch',
  UJET_CONFIGURATION: '/admin/uJetConfig',
  GENESYS_CONFIGURATION: '/admin/genesysConfig',
  IAM_INTEGRATION: '/admin/iamIntegration',
  CISCO_CONFIGURATION: '/admin/ciscoConfig',
  CISCO_WEBEX_CONFIGURATION: '/admin/webexConfig',
  LEGACY_API_ACCESS: '/admin/legacyApiAccess',
  CUSTOMER_IDP_CONFIG: '/admin/customerIdpConfig',
  RING_CENTRAL_CONFIGURATION: '/admin/ringCentralConfig',
  AVAYA_AXP_PUBLIC_CONFIGURATION: '/admin/avayaAxpPublicConfig',
  TRANSFER_USER_DATA: '/admin/transferUserData',
  BOT_ANALYTICS: '/botAnalytics',
  TRENDING_TOPICS: '/trendingTopics',
  AUTO_QA: '/autoQA',
  AUTO_QA_FORM_MANAGER: '/AutoQAFormManager',
  SMART_TAGS: '/smartTags',
  WELCOME_PAGE: '/welcomePage',
}

export const ORDERED_DEFAULT_PATHS = [
  ROUTE_PATHS_PREFIX.DASHBOARD,
  ROUTE_PATHS_PREFIX.RECORDINGS,
  ROUTE_PATHS_PREFIX.RECORDING_CONTROLS,
  ROUTE_PATHS_PREFIX.CONTACT_QUEUE,
  ROUTE_PATHS_PREFIX.SCHEDULING,
  ROUTE_PATHS_PREFIX.MESSAGING,
  ROUTE_PATHS_PREFIX.ANALYTICS,
  ROUTE_PATHS_PREFIX.BOT_ANALYTICS,
  ROUTE_PATHS_PREFIX.AGENT_EXPLORER,
  ROUTE_PATHS_PREFIX.REPORTS,
  ROUTE_PATHS_PREFIX.DATA_EXPLORER,
  ROUTE_PATHS_PREFIX.BI_INSIGHTS,
  ROUTE_PATHS_PREFIX.APPLICATION_MANAGEMENT,
  ROUTE_PATHS_PREFIX.WELCOME_PAGE,
]

export const EXACT_ROUTE_PATHS = new Set([
  ROUTE_PATHS_PREFIX.SCHEDULING,
])
